import "babel-polyfill";
import Vue from "vue/dist/vue.js";
import axios from "axios";
import translation from "./messages";
import VueI18n from "vue-i18n";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: "cs",
    messages: translation
});

var big_map = require("./big_map.js");
var result_card = require("./result_card.js");

if (document.getElementById("app")) {
    const moment = require("moment");
    require("moment/locale/cs");

    if (!Vue.moment) {
        Vue.use(require("vue-moment"), {
            moment
        });
    }

    var app = new Vue({
        i18n,
        delimiters: ["[[", "]]"],
        el: "#app",
        data: {
            total_pages_count: 0,
            actual_page: 1,
            actions: [],
            limit: 100,
            offset: 0,
            pages: [1, 2, 3],
            loading: false,
            leftTopLat: null,
            leftTopLon: null,
            rightBottomLat: null,
            rightBottomLon: null,
            total_count: 0,
            searchOnMove: false,

            // filters
            filterDialogOpen: false,
            activeFilter: "",

            fulltext: "",

            state: false,
            stateLabel: "Pouze aktuální",
            stateBadge: null,
            stateClass: "btn-outline-dark",

            comming: false,
            commingLabel: "Začne do 7 dní",
            commingBadge: null,
            commingClass: "btn-outline-dark",

            past: false,
            pastLabel: "Proběhlé",
            pastBadge: null,
            pastClass: "btn-outline-dark",

            hidden: false,
            hiddenLabel: "Skryté",
            hiddenBadge: null,
            hiddenClass: "btn-outline-dark",

            mine: false,
            mineLabel: "Moje",
            mineBadge: null,
            mineClass: "btn-outline-dark",

            allCityParts: [],
            cityPart: [],
            cityPartLabel: "Městská část",
            cityPartBadge: null,
            cityPartClass: "btn-outline-dark",

            allInvestors: [],
            investor: [],
            investorLabel: "Investor",
            investorBadge: null,
            investorClass: "btn-outline-dark",
            showOtherInvestors: false,

            // helpers used to handle request
            cancelToken: null,
            requestRunning: false,
            clickTimer: null,

            fullScreen: false
        },
        created() {
            if (window.location.href.includes("closure=True")) {
                this.closure = true;
            }
            this.getNewData(true, true);

            // get all city parts values
            this.allCityParts = [];
            var cityElements = document.getElementsByClassName("cityPart_selector_input");
            for (var i = 0; i < cityElements.length; i++) {
                this.allCityParts.push(cityElements[i].value);
            }

            // get all investors values
            this.allInvestors = [];
            var investorElements = document.getElementsByClassName("investor_selector_input");
            for (var i = 0; i < investorElements.length; i++) {
                this.allInvestors.push(investorElements[i].value);
            }
        },
        watch: {
            offset: function(val) {
                this.updatePager();
            },
            fulltext: function(val) {
                this.getNewData(true, false);
            },
            state: function(val) {
                if (this.state) {
                    this.stateClass = "btn-primary";
                    this.comming = false;
                    this.past = false;
                } else {
                    this.stateClass = "btn-outline-dark";
                }
                this.getNewData(true, false);
            },
            comming: function(val) {
                if (this.comming) {
                    this.commingClass = "btn-primary";
                    this.state = false;
                    this.past = false;
                } else {
                    this.commingClass = "btn-outline-dark";
                }
                this.getNewData(true, false);
            },
            past: function(val) {
                if (this.past) {
                    this.pastClass = "btn-primary";
                    this.state = false;
                    this.comming = false;
                } else {
                    this.pastClass = "btn-outline-dark";
                }
                this.getNewData(true, false);
            },
            hidden: function(val) {
                if (this.hidden) {
                    this.hiddenClass = "btn-primary";
                    this.state = false;
                } else {
                    this.hiddenClass = "btn-outline-dark";
                }
                this.getNewData(true, false);
            },
            mine: function(val) {
                if (this.mine) {
                    this.mineClass = "btn-primary";
                    this.state = false;
                } else {
                    this.mineClass = "btn-outline-dark";
                }
                this.getNewData(true, false);
            },
            cityPart: function(val) {
                if (val.length > 0 && val.length < 3) {
                    this.cityPartClass = "btn-primary";
                    this.cityPartBadge = null;
                    this.cityPartLabel = "Praha " + val.join(", ");
                } else if (val.length > 2) {
                    this.cityPartClass = "btn-primary";
                    this.cityPartBadge = val.length;
                    this.cityPartLabel = "Městská část";
                } else {
                    this.cityPartClass = "btn-outline-dark";
                    this.cityPartLabel = "Městská část";
                    this.cityPartBadge = null;
                }
            },
            investor: function (val) {
                if (val.length > 0) {
                    this.investorClass = "btn-primary";
                    this.investorBadge = val.length;
                } else {
                    this.investorClass = "btn-outline-dark";
                    this.investorBadge = null;
                }
            },
            activeFilter: function (val) {
                var element = document.getElementById("navbar_header");
                if (val == "investor" || val == "cityPart") {
                    element.classList.add("d-none");
                    element.classList.add("d-md-inline");
                    element.classList.remove("d-inline");
                }
                else {
                    element.classList.remove("d-none");
                    element.classList.remove("d-md-inline");
                    element.classList.add("d-inline");
                }
            }
        },
        methods: {
            getNewData: function(reload, nowait) {
                if (this.filterDialogOpen) {
                    return;
                }
                // mark request as running
                this.requestRunning = true;

                // check whether there is call to server already planned
                if (this.clickTimer) {
                    clearTimeout(this.clickTimer);
                }

                // check whether there is a call to server running
                // if so, cancel the request, new one will be planned instead
                if (this.cancelToken != null) {
                    this.cancelToken.cancel("Operation canceled by the user.");
                    this.cancelToken = null;
                }

                if (!nowait) {
                    // plan new call to server in 700ms
                    var self = this;
                    this.clickTimer = setTimeout(function() {
                        self.readDataFromServer(reload);
                    }, 500);
                } else {
                    this.readDataFromServer(reload);
                }
            },
            readDataFromServer: function(reload) {
                this.loading = true;
                const vm = this;

                // cancle already running request
                if (this.cancelToken != null) {
                    this.cancelToken.cancel("Operation canceled by the user.");
                }

                // initiate cancel token used to identify, whether ther is a request running already
                this.cancelToken = axios.CancelToken.source();

                if (reload) {
                    this.total_pages_count = 0;
                    this.actual_page = 1;
                    this.offset = 0;
                    this.total_count = 0;
                }
                axios
                    .get(this.buildQuery())
                    .then(function(response) {
                        vm.actions = response.data.objects;
                        vm.total_count = response.data.meta.total_count;
                        vm.total_pages_count = 1;
                        if (response.data.meta.total_count > vm.limit) {
                            vm.total_pages_count =
                                Math.floor(
                                    response.data.meta.total_count / vm.limit
                                ) + 1;
                        }

                        if (
                            response.data.meta.total_count > vm.limit &&
                            response.data.meta.total_count % vm.limit == 0
                        ) {
                            vm.total_pages_count = Math.floor(
                                response.data.meta.total_count / vm.limit
                            );
                        }

                        vm.offset = response.data.meta.offset;

                        vm.updatePager();

                        vm.cancelToken = null;
                        vm.loading = false;
                        vm.scrollToListTop();
                    })
                    .catch(function(e) {
                        if (axios.isCancel(e)) {
                            console.log("Request canceled", e.message);
                        } else {
                            console.log("Actions retrieval failed");
                            console.log(e);
                        }
                        vm.loading = false;
                    });
            },
            nextPage: function() {
                this.offset = this.offset + this.limit;
                this.getNewData(false, true);
            },
            previousPage: function() {
                this.offset = this.offset - this.limit;
                this.getNewData(false, true);
            },
            goToPage: function(val) {
                this.offset = (val - 1) * this.limit;
                console.log("Going to page " + val);
                this.getNewData(false, true);
            },
            buildQuery: function() {
                var query =
                    "/api/action/?limit=" +
                    this.limit +
                    "&offset=" +
                    this.offset;
                if (this.searchOnMove && this.leftTopLon != null) {
                    query += "&lon__gt=" + this.leftTopLon;
                }
                if (this.searchOnMove && this.leftTopLat != null) {
                    query += "&lat__lt=" + this.leftTopLat;
                }
                if (this.searchOnMove && this.rightBottomLon != null) {
                    query += "&lon__lt=" + this.rightBottomLon;
                }
                if (this.searchOnMove && this.rightBottomLat != null) {
                    query += "&lat__gt=" + this.rightBottomLat;
                }
                if (this.fulltext != null) {
                    query += "&fulltext=" + this.fulltext;
                }
                if (this.cityPart != null) {
                    query += "&cityPart=" + this.cityPart;
                }
                if (this.investor != null) {
                    query += "&investor=" + this.investor;
                }
                if (this.state) {
                    query += "&actual=true";
                }

                if (this.comming) {
                    query += "&comming=true";
                }

                if (this.past) {
                    query += "&past=true";
                }

                if (this.hidden) {
                    query += "&hiddenActions=true";
                }

                if (this.mine) {
                    query += "&mine=true";
                }

                return query;
            },
            mapPositionUpdated: function(coords) {
                if (this.searchOnMove) {
                    this.leftTopLon = coords[0]["x"];
                    this.leftTopLat = coords[0]["y"];
                    this.rightBottomLon = coords[1]["x"];
                    this.rightBottomLat = coords[1]["y"];
                    this.getNewData(true, false);
                }
            },
            updatePager: function() {
                var page = Math.floor((this.offset + this.limit) / this.limit);

                if (this.total_pages_count > 2) {
                    if (page == 1) {
                        this.pages = [1, 2, 3];
                    }

                    if (page > 2) {
                        this.pages = [page - 1, page, page + 1];
                    }

                    if (page > this.total_pages_count - 1) {
                        this.pages = [
                            this.total_pages_count - 2,
                            this.total_pages_count - 1,
                            this.total_pages_count
                        ];
                    }
                } else {
                    this.pages = [];
                    for (var i = 1; i < this.total_pages_count + 1; i++) {
                        this.pages.push(i);
                    }
                }

                this.actual_page = page;
            },
            activateFilter: function(val) {
                if (val == this.activeFilter) {
                    this.activeFilter = "";
                    this.filterDialogOpen = false;
                    this.getNewData(true, true);
                    document.body.classList.remove("no-scroll");

                } else {
                    this.activeFilter = val;
                    this.filterDialogOpen = true;
                    document.body.classList.add("no-scroll");
                }
            },
            deactivateFilters: function() {
                this.activeFilter = null;
                this.filterDialogOpen = false;
                this.getNewData(true, true);
                document.body.classList.remove("no-scroll");
            },
            resetFilters: function() {
                this.fulltext = "";
                this.cityPart = [];
                this.investor = [];
                this.leftTopLon = null;
                this.leftTopLat = null;
                this.rightBottomLon = null;
                this.rightBottomLat = null;
                this.comming = null;
                this.state = null;
                this.past = null;
                this.hidden = null;
                this.mine = null;
                this.filterDialogOpen = false;
                this.getNewData(true, true);
            },
            scrollToListTop: function() {
                window.scrollTo(0, 0);
            },
            highlightMarker: function(val) {
                this.$refs.bigMap.highlightMarker(val);
            },
            normaliseMarker: function(val) {
                this.$refs.bigMap.normaliseMarker(val);
            },
            selectAllCityParts: function () {
                this.cityPart = this.allCityParts;
            },
            deselectAllCityParts: function () {
                this.cityPart = [];
            },
            selectAllInvestors: function () {
                this.investor = this.allInvestors;
            },
            deselectAllInvestors: function () {
                this.investor = [];
            },
            showOtherInvestorsToggle: function () {
                this.showOtherInvestors = !this.showOtherInvestors;
            }
        }
    });
}
